import { pushEventToGTMDataLayer } from 'application/gtm_utils'

export function loginEvent(data) {
  pushEventToGTMDataLayer({
    event: "login",
    method: data.method,
    module_name: data.module_name
  });
}
